// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__14vVq","tab":"ProcedureTabs_tab__G6O_O"};